import { Chip } from "@narmi/design_system";
import Wire from "byzantine/src/Wire";
import { Dialog } from "cerulean";
import { useLocalization } from "@fluent/react";
import { CONSUMER_WIRE_STATUS_DEFINITIONS } from "../PaymentActivity/FileImport/statusDefinitionsConfig";
import { useCurrentUser } from "../contexts/CurrentUserContext";
import styles from "../PaymentActivity/FileImport/StatusDefinitionsDialog.module.scss";

interface WireStatusesDialogProps {
  isDialogOpen: boolean;
  closeDialog: () => void;
}
const WireStatusesDialog = ({
  isDialogOpen,
  closeDialog,
}: WireStatusesDialogProps) => {
  const { l10n } = useLocalization();
  const { currentUser } = useCurrentUser();
  const isBusinessUser = currentUser?.isBusiness();
  const wireStatuses = isBusinessUser
    ? Wire.getBusinessPendingStatuses()
    : Wire.getConsumerPendingStatuses();

  return (
    <Dialog
      isOpen={isDialogOpen}
      onUserDismiss={closeDialog}
      title={l10n.getString("title-wire-statuses", null, "Wire statuses")}
    >
      {isBusinessUser ? (
        <div className="margin--top--s">
          {wireStatuses.map(([status, meaning]) => (
            <div key={status} className="margin--bottom--l">
              <div className="attribute-label">{status}</div>
              <div>{meaning}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.dialogContent}>
          <div className={styles.statusList}>
            {CONSUMER_WIRE_STATUS_DEFINITIONS.map((definition, index) => (
              <div
                key={definition.key}
                className={`${styles.statusItem} ${index !== CONSUMER_WIRE_STATUS_DEFINITIONS.length - 1 ? styles.borderBottom : ""}`}
              >
                <div>
                  <Chip
                    kind={definition.kind}
                    startIcon={definition.startIcon}
                    label={l10n.getString(definition.labelKey)}
                  />
                </div>
                <p className={styles.statusDescription}>
                  {l10n.getString(definition.descriptionKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default WireStatusesDialog;
